import { useForm, SubmitHandler, Resolver } from 'react-hook-form';
import { PrizeFormType, validationSchema } from 'entities/prize/model';
import { useCreatePrizeCardDefaultValues } from 'entities/prize/lib';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCreatePrizeMutation } from 'entities/prize/api';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { PrizeForm } from './PrizeForm';

export const CreatePrizeForm = () => {
  const dispatch = useDispatch();
  const [createPrizeRequest] = useCreatePrizeMutation();

  const defaultValues = useCreatePrizeCardDefaultValues();
  const createPrizeForm = useForm<Partial<PrizeFormType>>({
    mode: 'all',
    resolver: yupResolver(validationSchema) as Resolver<Partial<PrizeFormType>>,
    defaultValues,
  });

  const onSubmit: SubmitHandler<Partial<PrizeFormType>> = (data) => {
    createPrizeRequest({ data }).then((res: any) => {
      dispatch(setDrawerOpen(false));
      if (data.prize_file && !res.error) {
        toast.success('Файл успешно сохранен', {
          position: toast.POSITION.TOP_RIGHT,
        });
        window.open('/downloads/tables-code', '_blank');
      }
    });
  };

  // @ts-ignore TODO refactor
  return (
    <PrizeForm
      form={createPrizeForm}
      onSubmit={onSubmit}
    />
  );
};
